/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reads_Heading_LabelInputs */

const en_reads_heading_label = /** @type {(inputs: Reads_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Similar Reads`)
};

const ar_reads_heading_label = /** @type {(inputs: Reads_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قراءات مشابهة`)
};

const bn_reads_heading_label = /** @type {(inputs: Reads_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সম্পর্কিত লেখা`)
};

const de_reads_heading_label = /** @type {(inputs: Reads_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ähnliche Beiträge`)
};

const es_reads_heading_label = /** @type {(inputs: Reads_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecturas similares`)
};

const fr_reads_heading_label = /** @type {(inputs: Reads_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lectures similaires`)
};

const pt_reads_heading_label = /** @type {(inputs: Reads_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leituras semelhantes`)
};

const zh_reads_heading_label = /** @type {(inputs: Reads_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类似读物`)
};

const tr_reads_heading_label = /** @type {(inputs: Reads_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benzer Okumalar`)
};

const ru_reads_heading_label = /** @type {(inputs: Reads_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Похожие чтения`)
};

const pl_reads_heading_label = /** @type {(inputs: Reads_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podobne odczyty`)
};

/**
* | output |
* | --- |
* | "Similar Reads" |
*
* @param {Reads_Heading_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const reads_heading_label = /** @type {((inputs?: Reads_Heading_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reads_Heading_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_reads_heading_label(inputs)
	if (locale === "bn") return bn_reads_heading_label(inputs)
	if (locale === "de") return de_reads_heading_label(inputs)
	if (locale === "es") return es_reads_heading_label(inputs)
	if (locale === "fr") return fr_reads_heading_label(inputs)
	if (locale === "pt") return pt_reads_heading_label(inputs)
	if (locale === "zh") return zh_reads_heading_label(inputs)
	if (locale === "tr") return tr_reads_heading_label(inputs)
	if (locale === "ru") return ru_reads_heading_label(inputs)
	if (locale === "pl") return pl_reads_heading_label(inputs)
	return en_reads_heading_label(inputs)
});